import { cn } from "@/lib/utils";
import { motorDirs } from "@/rc/attachments";
import "./rc.css";

const ARC = "M -15 -25.98 A 30 30 0 1 1 -25.98 15";
const HEAD = "M -29.5 8.9 L -21.65 12.5 L -30.3 17.5 Z";

const MotorSpin = ({ x, port, dir, testId }) => (
  <g transform={`translate(${x} 50)`} data-testid={testId} data-dir={dir === "R" ? "anticlockwise" : "clockwise"}>
    <rect x="-22" y="-22" width="44" height="44" rx="11" className="rc-motor-body" />
    <circle r="14" className="rc-motor-hub" />
    <g className={cn("rc-axle", dir === "R" && "is-ccw")}><path d="M -8 0 H 8 M 0 -8 V 8" /></g>
    <g transform={`scale(${dir === "R" ? -1 : 1} 1)`} className="rc-spin">
      <path d={ARC} />
      <path d={HEAD} className="rc-spin-head" />
    </g>
    <text y="48" textAnchor="middle" className="rc-motor-label">Port {port}</text>
  </g>
);

// Front view of the attachment motors, spinning the way they turn for the first button.
export const SpinDiagram = ({ a, testId }) => {
  const dirs = motorDirs(a);
  const two = a.ports.length === 2;
  const xs = two ? [62, 158] : [110];
  return (
    <svg viewBox="0 0 220 104" className="w-full overflow-visible" role="img" aria-label={`Attachment motors turning ${dirs.map((d) => (d === "R" ? "anticlockwise" : "clockwise")).join(" and ")}`}>
      {two && <line x1="62" y1="50" x2="158" y2="50" className="rc-motor-link" />}
      {two && <text x="110" y="10" textAnchor="middle" className="rc-motor-label" data-testid={`${testId}-group-label`}>{a.group === "same" ? "same way" : "opposite ways"}</text>}
      {a.ports.map((p, j) => <MotorSpin key={j} x={xs[j]} port={p} dir={dirs[j]} testId={`${testId}-motor-${j}`} />)}
    </svg>
  );
};
